import { render, staticRenderFns } from "./AdminAdwBanners.vue?vue&type=template&id=8e1aaac8&scoped=true&"
import script from "./AdminAdwBanners.vue?vue&type=script&lang=js&"
export * from "./AdminAdwBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1aaac8",
  null
  
)

export default component.exports